import { render } from "./OurPeoplePage.vue?vue&type=template&id=8a74590a"
import script from "./OurPeoplePage.vue?vue&type=script&lang=js"
export * from "./OurPeoplePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__